import React from 'react';
import {HtmlParse} from 'utils';
import PubSub from 'services/PubSub';
import primeLogo from 'images/prime/jumbo-prime-icon.svg'
import benefics from 'components/Drawers/benefics';
import StorageService from 'services/StorageService';
import TagManagerService from 'services/TagManager/';
import style from './style.scss';
import { actionsType } from 'config/constants'

const InformationText = () => {

    const _closeDrawer = () => {
        
        const userData = StorageService.getSecureItem('userData');
        let registered = userData.homePhone ? 'Registrado' : 'Cliente nuevo';
        TagManagerService.interaction('Clic botón No Gracias', registered, 'Jumbo Prime');

        PubSub.dispatch(actionsType.DRAWER.INVITATION_PRIME_CLOSE)
    }

    const openRegister = () => {

        const userData = StorageService.getSecureItem('userData');
        let registered = userData.homePhone ? 'Registrado' : 'Cliente nuevo';
        TagManagerService.interaction('Clic botón Quiero ser Jumbo Prime', registered, 'Jumbo Prime');  

        PubSub.dispatch(actionsType.DRAWER.INVITATION_PRIME_CLOSE)

        if(userData.firstName) {
            PubSub.dispatch(actionsType.DRAWER.REGISTER_PRIME_OPEN)
        } else {
            PubSub.dispatch(actionsType.DRAWER.LOGIN_OPEN)
        }
    }

    return (
        <div className={'drawer-container'}>
            <h1 className="drawer-title">¿Aún no tienes Jumbo Prime?</h1>

            <div className={'drawer-scroll drawer-prime-invitation-content'}>
                <div className="prime-invitation-logo">{HtmlParse(primeLogo)}</div>

                <div className="prime-invitation-info-wrap">Jumbo Prime es un programa de membresía que busca mejorar tu experiencia de compra en Jumbo a través de:</div>

                <div className="prime-invitation-benefics-wrap">
                    <ul className="prime-invitation-benefics-list-wrap">
                        {benefics && benefics.map((item, i) => {
                            return (
                                <li className="prime-invitation-benefics-list-item" key={i}>
                                    <i className="prime-invitation-benefics-list-icon">•</i>

                                    <div className="prime-invitation-benefics-list-text-wrap">
                                        <span className="prime-invitation-benefics-list-title">{item.title}</span>
                                        <span className="prime-invitation-benefics-list-subtitle">{HtmlParse(item.subtitle)}</span>
                                        {item.menssage && <span className="prime-invitation-benefics-list-menssage">{item.menssage}</span>}
                                    </div>
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </div>

            <div className="drawer-actions">
                <button className="secundary-btn prime-invitation-btn-no-thanks" onClick={_closeDrawer}>No, gracias</button>
                <button className="primary-btn prime-invitation-btn-jumbo-prime" onClick={() => openRegister()}>Quiero ser Jumbo Prime</button>
            </div>
        </div>
    )
}

export default InformationText;